import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { apiRequest } from '../services/api'
import { useAuth } from '../auth/AuthContext'

function Verify() {
  const navigate = useNavigate()
  const { setUser } = useAuth()

  const [email, setEmail] = useState(null)
  const [code, setCode] = useState('')
  const [error, setError] = useState(null)
  const [notice, setNotice] = useState('')
  const [loading, setLoading] = useState(false)
  const [resending, setResending] = useState(false)

  // 🔥 cargar email desde localStorage
  useEffect(() => {
    const storedEmail = localStorage.getItem('verifyEmail')
    if (!storedEmail) {
      navigate('/register')
      return
    }
    setEmail(storedEmail)
    setNotice(localStorage.getItem('verifyNotice') || '')
    localStorage.removeItem('verifyNotice')
  }, [navigate])

  const resend = async () => {
    setError(null)
    setResending(true)
    try {
      const response = await apiRequest('/api/auth/resend-verification', { method: 'POST', auth: false, body: { email } })
      setNotice(response.message || 'Te enviamos un código nuevo')
    } catch (err) {
      setError(err.message || 'No pudimos reenviar el código')
    } finally {
      setResending(false)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError(null)

    if (!/^[A-Z2-9]{6}$/.test(code)) {
      setError('Ingresá el código de 6 caracteres')
      return
    }

    try {
      setLoading(true)

      const response = await apiRequest('/api/auth/verify', {
        method: 'POST',
        auth: false,
        body: {
          email,
          code,
        },
      })

      // limpiar storage
      localStorage.removeItem('verifyEmail')
      setUser(response.user)
      navigate('/welcome')
    } catch (err) {
      setError(err.message || 'Código inválido o expirado')
    } finally {
      setLoading(false)
    }
  }

  if (!email) return null

  return (
    <Page>
      <Card>
        <Title>Confirmá tu cuenta</Title>

        <Message>
          Ingresá el código enviado a<br />
          <strong>{email}</strong><br />
          <small>Revisá también Spam o Correo no deseado.</small>
        </Message>
        {notice && <Notice role="status">{notice}</Notice>}

        <form onSubmit={handleSubmit}>
          <Input
            type="text"
            placeholder="Código"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase().replace(/[^A-Z2-9]/g, ''))}
            maxLength={6}
            inputMode="text"
            autoComplete="one-time-code"
          />

          <PrimaryButton type="submit" disabled={loading}>
            {loading ? 'Verificando…' : 'Verificar'}
          </PrimaryButton>
        </form>

        {error && <Message error>{error}</Message>}
        <ResendButton type="button" onClick={resend} disabled={resending}>
          {resending ? 'Enviando…' : 'Reenviar código'}
        </ResendButton>
      </Card>
    </Page>
  )
}

export default Verify

// =====================
// STYLES
// =====================





/* ===== styles ===== */

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:radial-gradient(circle at 85% 20%,rgba(198,111,78,.14),transparent 30%),#f7f6f1;
`

const Card = styled.div`
  background: #fff;
  padding: 40px;
  border-radius: 24px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
`

const Title = styled.h2`
  margin-bottom: 16px;
  font-size:clamp(2rem,5vw,3.4rem);color:#243e45;
`

const Message = styled.p`
  color: ${({ error }) => (error ? '#d32f2f' : '#555')};
`

const Notice = styled.p`
  padding: 12px 14px;
  border-radius: 12px;
  background: #edf5f2;
  color: #294f58;
  line-height: 1.45;
`

const Input = styled.input`
  width: 100%;
  padding: 12px;
  margin: 16px 0;
  border:1px solid #d7dfde;border-radius:14px;font-size:1.8rem;text-align:center;letter-spacing:.45em;color:#243e45;
`

const PrimaryButton = styled.button`
  width: 100%;
  padding: 12px;
  border:0;border-radius:999px;background:#c66f4e;color:white;font-weight:800;cursor:pointer;
`

const ResendButton = styled.button`
  margin-top: 18px;
  border: 0;
  background: transparent;
  color: #294f58;
  font-weight: 750;
  text-decoration: underline;
  cursor: pointer;
  &:disabled { opacity: .55; cursor: wait; }
`
